import "./KDS.scss"

import React from "react"
import request from "request"

// Read-only view of how this station is configured. Everything shown here is
// managed in Venue Admin -- the device only displays it so kitchen staff can
// confirm routing without leaving the floor. There are deliberately no edit
// controls.
class SettingsView extends React.Component {
  state = { loading: true, data: null }

  componentDidMount() {
    request.get("/kds/settings")
      .then(({ data }) => this.setState({ data, loading: false }))
      .catch(() => this.setState({ loading: false }))
  }

  renderList(items, anyHint) {
    if (!items || items.length === 0) {
      return <span className="setting-any">{anyHint}</span>
    }
    return (
      <ul className="setting-list">
        {items.map((item) => <li key={item}>{item}</li>)}
      </ul>
    )
  }

  render() {
    const { loading, data } = this.state

    if (loading) {
      return <div className="KDSApp"><div className="empty-state">Loading…</div></div>
    }
    if (!data) {
      return <div className="KDSApp"><div className="empty-state">Couldn't load settings.</div></div>
    }

    const prepMinutes = Math.round((data.prepTimeSeconds || 0) / 60)

    return (
      <div className="KDSApp KDSSettings">
        <div className="settings-note notification is-info is-light">
          These settings are read-only here. To change routing, categories, the
          prep target, or the printer for this station, edit it in{" "}
          <strong>Venue Admin → Kitchen Stations</strong>.
        </div>

        <div className="settings-grid">
          <div className="setting-card">
            <div className="setting-pair">
              <div>
                <h2>Prep target</h2>
                <div className="setting-value">{prepMinutes} min</div>
              </div>
              <div>
                <h2>Printer</h2>
                <div className="setting-value">{data.printer || <span className="setting-any">No printer (screen only)</span>}</div>
              </div>
            </div>
          </div>

          <div className="setting-card">
            <h2>Categories</h2>
            {this.renderList(data.categories, "Any category")}
          </div>

          <div className="setting-card">
            <h2>Stores routed here (all terminals)</h2>
            {this.renderList(data.stores, "Any store")}
          </div>

          <div className="setting-card">
            <h2>Terminals routed here</h2>
            {this.renderList(data.terminals, "Any terminal")}
          </div>
        </div>
      </div>
    )
  }
}

export default SettingsView
